import React from 'react';
import './index.scss';
import {connect} from 'react-redux';
import {bindActionCreators, Dispatch} from 'redux';
import {ApplicationState} from '../../store';
import {User, UserTypes} from '../../store/ducks/user/types';
import * as UserActions from '../../store/ducks/user/actions';
import {Param, ParamTypes} from '../../store/ducks/param/types';
import * as ParamActions from '../../store/ducks/param/actions';
import { Redirect, Link } from "react-router-dom";
import Header from '../Header';
import Footer from '../Footer';
import Api from '../../services/api';
import {Diversos} from '../../services/diversos';

import InputMask from "react-input-mask";
import Row from 'react-bootstrap/Row'
import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tab'
import Button from 'react-bootstrap/Button'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import InputGroup from 'react-bootstrap/InputGroup'
import {Spinner} from 'react-bootstrap'

import logoPreta from '../../assets/Images/domakoski-preta.jpg'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEyeSlash, faEye, faArrowLeft, faArrowRight, faExclamationTriangle, faCircleNotch } from '@fortawesome/free-solid-svg-icons'
  

interface StateProps { 
  user: User;
  param: Param;
}

interface DispatchProps {
  setParam(data: Param): void;
}

interface OwnProps {}

type Props = StateProps & DispatchProps & OwnProps;  

class PasswordReset extends React.Component<Props> {

  api: any = null;
  state: any = null;

  novoCepRef: any = null;
  novoRuaRef: any = null;
  novoNumeroRef: any = null;
  novoBairroRef: any = null;
  novoCidadeRef: any = null;
  novoUfRef: any = null;
  novoComplementoRef: any = null;

  constructor(props) {
    super(props);

    this.api = new Api();

    this.state = {
      redirect: null,
      pswHidden: true,
      newPswHidden: true,
      confHidden: true,

      isLoadingCustomer: true,
      customer: null,
      customerHasError: false,
      customerHasErrorTitle: null,
      customerHasErrorMsg: null,
      customerHasSuccess: false,
      customerHasSuccessTitle: null,
      customerHasSuccessMsg: null,
    }

    this.toggleShow = this.toggleShow.bind(this);

  }

  toggleShow (input: number) {
    if (input === 1) {
      this.setState({ pswHidden: !this.state.pswHidden });
      return;
    }

    else if (input === 2) {
      this.setState({ newPswHidden: !this.state.newPswHidden });
      return;
    }

    this.setState({ confHidden: !this.state.confHidden })
  }

  componentDidMount () {
    const self = this;

    if (( self.props.user ) && ( self.props.user.status !== false )) { 
      self.getCustomer();
    }
  }

  private async getCustomer () {
    const self = this;

   self.setState({isLoadingCustomer: true});

    try {
      const {data} = await self.api.get(`/customer/${self.props.user.codigo}`);

      if ( data.status == false ) {
        throw new Error('Cadastro de cliente não localizado.');
      } else {
        self.setState({customer: data.msg});
      }

    } catch (e) {
      console.error(e);

      self.setState({
        customer: null,
        customerHasError: true,
        customerHasErrorTitle: 'Cadastro não localizado',
        customerHasErrorMsg: e.message
      });

    } finally {
      self.setState({isLoadingCustomer: false});
    }
  }

  private async handleSubmit () {
    const self = this;
    let link: string = `/customer/${self.props.user.codigo}`;
    let param: any = {};

      // ===================== Arrumar validação do submit ===================== // 

      if (( !self.state.senhaAtual ) || ( !self.state.senhaNova ) || ( !self.state.confSenhaNova )) {
        self.setMsg( 'error', "Formulário incompleto", "Necessário preencher todos os campos obrigatórios (*) do formulário para continuar.");
        return;
      }

      if ( self.state.senhaNova !== self.state.confSenhaNova ) {
        self.setMsg( 'error', "Confirmação da senha inválida", "Senha nova e sua confirmação não são iguais.");
        return;
      }

      param.senha = self.state.senhaAtual;
      param.senhaNova = self.state.senhaNova;
      link = `/customer/${self.props.user.codigo}/troca-senha`;

    self.setState({ isLoading: true });

    try {
      const {data} = await self.api.put(link, param);

      if (!data.status) {
        throw new Error(data.msg);
      } else {
        self.setMsg( 'success', "Sucesso", `Cadastro atualizado com sucesso.`);
      }

    } catch (e) {
      console.error(e);
      self.setMsg( 'error', "Atenção", `Não foi possível atualizar cadastro. ${e.message}`);
    } finally {
      self.setState({ isLoading: false });
    }
  }

  /**
   * FUNCAO PARA SETAR ALERT DE ERROR OU SUCESSO COM TEMPORIZADOR
   * @param type 
   * @param title 
   * @param msg 
   */
  private async setMsg ( type: string, title: string, msg: string) {
    const self = this;
    let timeout = 5000;

    if ( type === "error" ) {
      
      self.setState({
        customerHasError: true,
        customerHasErrorTitle: title,
        customerHasErrorMsg: msg,
      }, () => {
        setTimeout(() => self.setState({ customerHasError: false }), timeout)
      });

    } else {

      self.setState({
        customerHasSuccess: true,
        customerHasSuccessTitle: title,
        customerHasSuccessMsg: msg,
      }, () => {
        setTimeout(() => self.setState({ customerHasSuccess: false }), timeout)
      });

    }
  }

  render () {
    return (
      <>
        {
          this.state.isLoadingCustomer === true ?
          <>
            <span className="py-3 w-100 m-auto text-center d-flex justify-content-center">
              <FontAwesomeIcon icon={faCircleNotch} spin={true} className="text-center m-auto spinner" style={{fontSize: 24}}/>
            </span>
          </>
          :
          <>
            {
              this.state.customerHasSuccess &&
              <div className="alert alert-success">
                <strong> {this.state.customerHasSuccessTitle} </strong>
                <br/>
                { this.state.customerHasSuccessMsg }
              </div>
            }

            {
              this.state.customerHasError &&
              <div className="alert alert-danger">
                <strong> {this.state.customerHasErrorTitle} </strong>
                <br/>
                {this.state.customerHasErrorMsg}
              </div>
            }

          <div className="data-input-wrapper">
            <Form.Row className="mx-0 pb-3">
              <Form.Label> Senha atual * </Form.Label>
              <InputGroup>
                <Form.Control
                type={this.state.pswHidden ? "password" : "text"}
                placeholder="Senha"
                className={`user-input ${(this.state.novoHasError) ? 'input-error' : ''}`}
                value={this.state.senhaAtual}
                aria-label="Senha"
                aria-describedby="Mostrar senha"
                onChange={(event) => this.setState({senhaAtual: event.target.value})} 
                />
                <InputGroup.Append>
                  <Button variant="outline-secondary" className="visibility" title="Mostrar senha" onClick={() => this.toggleShow(1)}>
                  <FontAwesomeIcon icon={(this.state.pswHidden) ? faEyeSlash : faEye}/> </Button>
                </InputGroup.Append>
              </InputGroup>
            </Form.Row>
            <Form.Row className="mx-0 pb-3">
              <Form.Label> Nova senha * </Form.Label>
              <InputGroup>
                <Form.Control
                type={this.state.newPswHidden ? "password" : "text"}
                placeholder="Nova senha"
                className={`user-input ${(this.state.novoHasError) ? 'input-error' : ''}`}
                value={this.state.senhaNova}
                aria-label="Senha"
                aria-describedby="Mostrar senha"
                onChange={(event) => this.setState({senhaNova: event.target.value})} 
                />
                <InputGroup.Append>
                  <Button variant="outline-secondary" className="visibility" title="Mostrar senha" onClick={() => this.toggleShow(2)}>
                  <FontAwesomeIcon icon={(this.state.newPswHidden) ? faEyeSlash : faEye}/> </Button>
                </InputGroup.Append>
              </InputGroup>
            </Form.Row>
            <Form.Row className="mx-0 pb-3">
            <Form.Label> Confirme a nova senha * </Form.Label>
              <InputGroup>
                <Form.Control
                type={this.state.confHidden ? "password" : "text"}
                placeholder="Confirmação da nova senha"
                className={`user-input ${(this.state.novoHasError) ? 'input-error' : ''}`}
                value={this.state.confSenhaNova}
                aria-label="Senha"
                aria-describedby="Mostrar senha"
                onChange={(event) => this.setState({confSenhaNova: event.target.value})} 
                />
                <InputGroup.Append>
                  <Button variant="outline-secondary" className="visibility" title="Mostrar senha" onClick={() => this.toggleShow(3)}>
                  <FontAwesomeIcon icon={(this.state.confHidden) ? faEyeSlash : faEye}/> </Button>
                </InputGroup.Append>
              </InputGroup>
            </Form.Row>
          </div>

          <div className="data-actions">
            <a href="/meu-cadastro" className="btn-link-action"> Cancelar </a>
            <Button className="btn-secondary-action" type="submit" onClick={this.handleSubmit.bind(this)} disabled={this.state.isLoading}>
              { (this.state.isLoading) ? 'Salvando...' : 'Salvar' }
            </Button>
          </div>
          </>
        }
      </>
    );
  }
}


const mapStateToProps = (state: ApplicationState) => ({
  user: state.user.data,
  param: state.param.data
});

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators({...UserActions, ...ParamActions}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PasswordReset);
